import SoundTitleService from 'src/modules/soundTitle/SoundTitleService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'SOUNDTITLE_FORM';

const soundTitleFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: soundTitleFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await SoundTitleService.find(id);
      }

      dispatch({
        type: soundTitleFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundTitleFormActions.INIT_ERROR,
      });

      getHistory().push('/sound-title');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: soundTitleFormActions.CREATE_STARTED,
      });

      await SoundTitleService.create(values);

      dispatch({
        type: soundTitleFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.soundTitle.create.success'),
      );

      getHistory().push('/sound-title');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundTitleFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: soundTitleFormActions.UPDATE_STARTED,
      });

      await SoundTitleService.update(id, values);

      dispatch({
        type: soundTitleFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.soundTitle.update.success'),
      );

      getHistory().push('/sound-title');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: soundTitleFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default soundTitleFormActions;
